// src/pages/Home/About.jsx
import React, { useState, useEffect } from "react";
import { getSettings } from "../../services/settingsServices";

// (optionnel) rend /uploads/... absolu vers l’API
const toAbsolute = (u) => {
  if (!u) return "";
  const s = String(u).trim();
  if (/^https?:\/\//i.test(s) || s.startsWith("data:") || s.startsWith("blob:"))
    return s;
  if (!s.startsWith("/uploads")) return s;
  const base = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";
  return `${base}${s}`;
};

function About() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getSettings();
        if (data.length > 0) {
          setSettings(data[0]);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des paramètres:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  if (loading) {
    return (
      <section
        id="about"
        className="py-12 md:py-16 bg-slate-100 dark:bg-slate-900"
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center gap-6 animate-pulse">
            <div className="w-36 h-36 sm:w-44 sm:h-44 rounded-3xl bg-slate-200 dark:bg-slate-700" />
            <div className="w-full space-y-3">
              <div className="h-5 w-1/2 bg-slate-200 dark:bg-slate-700 rounded" />
              <div className="h-4 w-full bg-slate-200 dark:bg-slate-700 rounded" />
              <div className="h-4 w-5/6 bg-slate-200 dark:bg-slate-700 rounded" />
              <div className="h-4 w-2/3 bg-slate-200 dark:bg-slate-700 rounded" />
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!settings) return null;

  const logo = settings.logo_comite || "/img/logo_club.png";
  const title = settings.about_title || "À propos du comité";
  const content = settings.about_content || "";

  return (
    <section
      id="about"
      className="py-12 md:py-16 bg-slate-100 dark:bg-slate-900 text-slate-900 dark:text-slate-100"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center">
          {/* Logo au-dessus, plus gros */}
          <div className="relative mb-6 sm:mb-8">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-orange-400/40 via-primary/30 to-sky-500/40 blur-xl opacity-80 dark:opacity-90" />
            <div className="relative bg-white dark:bg-slate-800 rounded-3xl shadow-xl border border-slate-200/80 dark:border-slate-700/80 px-6 py-6 sm:px-8 sm:py-8 flex items-center justify-center">
              <img
                src={toAbsolute(logo)}
                alt="Logo du comité"
                className="max-h-64 sm:max-h-64 md:max-h-64 w-auto object-contain"
              />
            </div>
          </div>

          {/* Texte */}
          <div className="font-montserrat max-w-3xl">
            <p className="text-xs font-semibold tracking-[0.3em] uppercase text-primary mb-2">
              Le comité
            </p>
            <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-4">
              {title}
            </h2>

            <div
              className="mt-2 text-sm sm:text-base leading-relaxed space-y-3 text-left sm:text-justify"
              dangerouslySetInnerHTML={{ __html: content }}
            />

            {/* Ligne décorative */}
            <div className="pt-5 flex justify-center">
              <div className="h-px w-24 bg-gradient-to-r from-primary via-orange-400 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
